//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('customerBusCo', {
//        templateUrl: 'views/components/views/customerBusCo/customerBusCo.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'utilityService', 'modalService', 'translateService', 'customerBusCoService', 'logisticService', function ($stateParams, stateService, utilityService, modalService, translateService, customerBusCoService, logisticService) {
            
//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let customerBusCoKeyno = $stateParams.customerbusco_keyno;

//            let translations = {
//            	error: '',
//            	ok: ''
//            };

//            vm.model = {
//                accCustNoButtons: [
//                    { id: 'calculator', icon: 'fa fa-calculator', color: 'primary', type: 'primary', onClick: () => openCalculator('acc_cust_no') },
//                    { id: 'new', icon: 'fa fa-plus', color: 'primary', type: 'primary', onClick: () => count('acc_cust_no') }
//                ],
//                accSuppNoButtons: [
//                    { id: 'calculator', icon: 'fa fa-calculator', color: 'primary', type: 'primary', onClick: () => openCalculator('acc_supp_no') },
//                    { id: 'new', icon: 'fa fa-plus', color: 'primary', type: 'primary', onClick: () => count('acc_supp_no') }
//                ],
//                edit: {},
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE CALL

//            async function loadEdit() {
//                vm.model.edit = (await customerBusCoService.getCustomerBuscos({ customerbusco_keyno: customerBusCoKeyno }))[0];
//            }

//            // #endregion LOAD PROCEDURE CALL

//            // #region COUNT NEXT NUMBER PROCEDURE CALLS

//            function count(id) {
//                switch (id) {
//                    case 'acc_cust_no':
//                        if (utilityService.validateParmsValue(vm.model.edit.acc_cust_no_counter_id, true) !== true) return;

//                        return logisticService.getNextCounterNumber({ counter_id: vm.model.edit.acc_cust_no_counter_id }).then(function (response) {
//                            if (response[0].nextnumber !== '') vm.model.edit.acc_cust_no = response[0].nextnumber;
//                        });
//                        break;
//                    case 'acc_supp_no':
//                        if (utilityService.validateParmsValue(vm.model.edit.acc_supp_no_counter_id, true) !== true) return;

//                        return logisticService.getNextCounterNumber({ counter_id: vm.model.edit.acc_supp_no_counter_id }).then(function (response) {
//                            if (response[0].nextnumber !== '') vm.model.edit.acc_supp_no = response[0].nextnumber;
//                        });
//                        break;
//                    default:
//                        break;
//                };
//            }

//            // #endregion COUNT NEXT NUMBER PROCEDURE CALLS

//            // #region OPEN CALCULATOR DIALOGUE BOX FUNCTION

//            function openCalculator(number) {
//                modalService.showCalculator(vm.model.edit[number]).then(function (value) {
//                    vm.model.edit[number] = value;
//                });
//            }

//		    // #endregion OPEN CALCULATOR DIALOGUE BOX FUNCTION

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                customerBusCoService.saveObj(vm.model.edit).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                    	modalService.show({
//                    		type: 'warning',
//                    		title: translations.error,
//                    		message: response[0].errormessage,
//                    		buttons: [{
//                    			label: translations.ok,
//                    			cssClass: 'btn-warning',
//                    			action: function (dialogItself) {
//                    				dialogItself.close();
//                    				vm.model.lockedSave = false;
//                    			}
//                    		}]
//                    	});
//                    } else {
//                    	vm.model.lockedSave = false;
//                    	stateService.back();
//                    }
//                });
//            }

//		    // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                translate();
//                loadEdit();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
